// Module
var code = "<p> <label>Divisions</label> <input type=\"range\" min=\"0\" max=\"10\" step=\"1\" oninput=\"roundedBox.p.divisions.set(event.target.value)\"> </p> <p> <label>Bevel</label> <input type=\"range\" min=\"0\" max=\"1\" step=\"0.01\" oninput=\"roundedBox.p.bevel.set(event.target.value)\"> </p> ";
// Exports
export default code;